import {MenuItem, Notification, Typography} from '@genestack/ui';
import React from 'react';
import {useLocation} from 'wouter';

import {isDocumentDraft} from '../../../../../../utils/document';
import {useDiscardWorkingCopyMutation} from '../../../hooks/use-discard-working-copy-mutation';
import {showNotification} from '../../../../../../providers/notifications-center/show-notification';

interface Props {
    document: EditModeDoc;
    disabled: boolean;
}

export function DiscardItem(props: Props) {
    const [, navigate] = useLocation();
    const discardWorkingCopy = useDiscardWorkingCopyMutation();

    const handleDiscard = () => {
        try {
            discardWorkingCopy.mutate(props.document);

            if (isDocumentDraft(props.document)) {
                navigate('/');
            }
        } catch (error) {
            showNotification(
                <Notification>
                    <Typography intent="alarm">Error: Not possible to discard the draft</Typography>
                    {error instanceof Error ? <Typography>{error.message}</Typography> : null}
                </Notification>
            );
        }
    };

    return (
        <MenuItem key="discard" onClick={handleDiscard} disabled={props.disabled}>
            Discard {isDocumentDraft(props.document) ? 'draft' : 'working copy'}
        </MenuItem>
    );
}
